import React, { useState } from 'react';
import { useStores } from '../../hooks/use-stores';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';

const DownloadPlantTemplateButton = () => {
  const [downloadInProgress, setDownloadInProgress] = useState<boolean>(false);
  const [showMissingPermissionsError, setShowMissingPermissionsError] = useState<boolean>(false);
  const { newAuthStore, settingsStore } = useStores();
  const { plantId } = settingsStore;
  const { t } = useTranslation();

  const userHasPermissionsToDownload = newAuthStore.user && newAuthStore.user?.super;

  const downloadTemplate = async () => {
    try {
      setDownloadInProgress(true);
      const response = await newAuthStore.makeAuthorizedRequest(`/api/plant/${plantId}/configuration/template`);

      const blob = new Blob([JSON.stringify(response, null, 2)], {
        type: 'application/json',
      });
      const url = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.href = url;
      tempLink.setAttribute('download', `plant-${plantId}-configuration-template.json`);

      // Append the link to the document body to simulate a click
      document.body.appendChild(tempLink);
      tempLink.click();

      // Clean up
      tempLink.parentNode?.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setDownloadInProgress(false);
    }
  };

  const onDownloadClick = async () => {
    if (userHasPermissionsToDownload) {
      await downloadTemplate();
      return;
    }
    setShowMissingPermissionsError(true);
  };

  return (
    <>
      <Button
        id={'download-plant-template'}
        onClick={onDownloadClick}
        download={`plant-${settingsStore.plantId}-configuration-template.json`}
        title={t('Download the plant configuration template')}
        disabled={downloadInProgress || showMissingPermissionsError}
      >
        {downloadInProgress ? t('Downloading...') : t('Export plant template')}
        <i
          className={`fa ${downloadInProgress ? 'fa-spin fa-spinner' : 'fa-download'}`}
          style={{
            marginLeft: '6px',
          }}
        />
      </Button>
      {showMissingPermissionsError && (
        <p className="text-danger">
          {t('You don\'t have permission to download the plant template.')}
        </p>
      )}
    </>
  );
};

export default DownloadPlantTemplateButton;
